class CoastlineStickyAddToCart {
  constructor(element) {
    this.element = element;
    this.section = element.closest('product-info');
    this.mainButton = this.section?.querySelector('.product-form__submit');
    this.price = this.section?.querySelector('[id^="price-"]');
    this.stickyButton = element.querySelector('[data-coastline-sticky-button]');
    this.stickyPrice = element.querySelector('[data-coastline-sticky-price]');

    if (!this.mainButton || !this.stickyButton) return;

    this.sync();
    this.observeVisibility();
    this.observeProductState();
  }

  sync() {
    const mainLabel = this.mainButton.querySelector('span')?.textContent.trim();
    const visiblePrice = this.price?.querySelector(
      '.price__sale .price-item--sale, .price__regular .price-item--regular, .price-item--regular'
    );

    this.stickyButton.disabled = this.mainButton.disabled;
    if (mainLabel) this.stickyButton.textContent = mainLabel;
    if (visiblePrice && this.stickyPrice) this.stickyPrice.textContent = visiblePrice.textContent.trim();
  }

  observeVisibility() {
    this.visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.element.classList.toggle('is-visible', show);
        this.element.setAttribute('aria-hidden', show ? 'false' : 'true');
      },
      { threshold: 0 }
    );
    this.visibilityObserver.observe(this.mainButton);
  }

  observeProductState() {
    this.stateObserver = new MutationObserver(() => this.sync());
    this.stateObserver.observe(this.mainButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true
    });
    if (this.price) {
      this.stateObserver.observe(this.price, { childList: true, subtree: true });
    }
  }
}

const initCoastlineProduct = (root = document) => {
  root.querySelectorAll('[data-coastline-sticky-atc]:not([data-initialized])').forEach((element) => {
    element.dataset.initialized = 'true';
    new CoastlineStickyAddToCart(element);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCoastlineProduct());
} else {
  initCoastlineProduct();
}

document.addEventListener('shopify:section:load', (event) => initCoastlineProduct(event.target));
